import {batchActions} from "redux-batched-actions";
import {changePage, displayErrorMessage, displaySuccessMessage, updatePageDetails} from '@insticator/insticator-ui'; // iui-utils
import { asyncRequestRatingWidget, asyncHasRatingsUnit } from 'utils/api/ratings';

export const RECEIVE_RATING_DATA = "RECEIVE_RATING_DATA";
export const RATING_REQUEST_PENDING = "RATING_REQUEST_PENDING";
export const APPROVING_RATING = "APPROVING_RATING";
export const FETCHING_RATINGS_DATA = "FETCHING_RATINGS_DATA";
export const RECEIVE_RATINGS_UNIT_CHECK = "RECEIVE_RATINGS_UNIT_CHECK";

export const SELECT_RATINGS_SITE = "SELECT_RATINGS_SITE";


const ratingStatusDataSuccess = data => batchActions([receiveRatingData(data)]);
const ratingStatusSuccess = (message) => batchActions([ratingRequestPending(false), displaySuccessMessage(message)]);
const ratingStatusFail = () => batchActions([ratingRequestPending(false), displayErrorMessage("There was an issue making your request.") ]);

export const selectRatingSite = site => ({
    type: SELECT_RATINGS_SITE,
    site
});

const receiveRatingData = data => ({
    type: RECEIVE_RATING_DATA,
    data
});

const ratingRequestPending = status => ({
    type: RATING_REQUEST_PENDING,
    status
});

const fetchingRatingsData = status => ({
    type: FETCHING_RATINGS_DATA,
    status
});

export const receiveRatingsUnitCheck = state => ({
    type: RECEIVE_RATINGS_UNIT_CHECK,
    state
});

const delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const requestRatingWidget = (accountUUID) => dispatch => { 
    dispatch(ratingRequestPending(true));
    asyncRequestRatingWidget(accountUUID)
        .then(response => {
            dispatch(ratingStatusDataSuccess(response.data))
            if (response.data !== true) {
                delay(100)
                    .then(response => dispatch(ratingStatusSuccess("Your request was approved")))
            } else {
                dispatch(ratingStatusSuccess("Your request was sent successfully"))
            }
        })
        .catch(err => dispatch(ratingStatusFail()))
};

export const checkForRatingsUnit = (accountUUID) => dispatch => {
    dispatch(fetchingRatingsData(true));
    asyncHasRatingsUnit(accountUUID)
        .then(response => dispatch(receiveRatingsUnitCheck(response.data)))
        .catch(err => console.log(err))
};
